function GatewayView({device}) {
  return (
    <ul>
      <li>
        <strong>Status</strong>: {device?.model?.status_message}
        &nbsp;<span className={`status-icon signal ${device?.model?.status}`}>{device?.model?.status}</span>
      </li>
      <li><strong>Network IP</strong>: {device?.model?.config?.network_ip}</li>
      <li><strong>Gateway IP</strong>: {device?.model?.config?.gateway_ip}</li>
      <li><strong>Firmware Vesion</strong>: {device?.model?.config?.firmware_version}</li>
      <li><strong>Firmware Updated</strong>: {device?.model?.config?.firmware_date}</li>
    </ul>
  )
}

export default GatewayView;
